
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-renewal/[slug]",
      function () {
        return require("private-next-pages/trademark-renewal/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-renewal/[slug]"])
      });
    }
  